<template>
  <div class="page-container">
    <!-- <el-card class="page-content" shadow="never" v-if="showList"> -->
    <el-card class="page-content" shadow="never">
      <el-breadcrumb separator="/" class="page-breadcrumb">
        <el-breadcrumb-item>
          <div class="breadcrumb">
            <div class="left"></div>
            <div class="right"><h2>赠币管理</h2></div>
          </div>
        </el-breadcrumb-item>
      </el-breadcrumb>
      <div class="page-actions">
        <div class="select">
          <div class="item">
            <!-- <div class="txt">用户UID：</div> -->
            <div class="ipt">
              <el-input
                placeholder="用户UID"
                size="mini"
                clearable
                v-model="userId"
              >
              </el-input>
            </div>
          </div>
          <!-- <div class="item">
            <div class="txt">邀请人UID</div>
            <div class="ipt">
              <el-input placeholder="邀请人UID" clearable v-model="inviteBy">
              </el-input>
            </div>
          </div>
          <div class="item">
            <div class="txt">合伙人UID</div>
            <div class="ipt">
              <el-input placeholder="合伙人UID" clearable v-model="channelUserId">
              </el-input>
            </div>
          </div> -->
          <div class="item">
            <!-- <div class="txt">时间</div> -->
            <div class="ipt">
              <el-date-picker
                v-model="value1"
                type="daterange"
                size="mini"
                align="right"
                format="yyyy - MM - dd 日"
                value-format="yyyy-MM-dd"
                unlink-panels
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="changeTime($event)"
                :picker-options="pickerOptions"
              >
              </el-date-picker>
            </div>
          </div>
          <!-- <div class="item">
            <el-button size="mini" @click="searchYesterday">昨日</el-button>
          </div>
          <div class="item">
            <el-button size="mini" @click="searchToday">今日</el-button>
          </div> -->
          <div class="item">
            <!-- <el-button size="mini" type='primary' @click="donateCoin">赠币</el-button> -->
            <DonateCoin
              v-if="$hasPerm('tenant:partner_gift_coin:donate') && !isCustom"
              :refresh2="refreshList"
              :userId="userId"
            ></DonateCoin>
          </div>
          <div class="item">
            <el-button size="mini" type="primary" @click="handleSearch"
              >查询</el-button
            >
          </div>
        </div>
      </div>
      <div class="pl_total_box">
        <div class="pl_total">
          <span>赠币汇总</span>
          <span></span>
          <span>{{ infoTotal | fixD(6) }}</span>
          <span>USDT</span>
        </div>
      </div>
      <user-list @refresh="refreshList"></user-list>
    </el-card>
    <!-- 添加用户信息弹框 -->
    <el-dialog
      :visible.sync="googleVisible"
      title="谷歌验证码"
      width="300px"
      @close="handleCloseGoogle"
    >
      <el-form :model="form" ref="form" label-width="110px">
        <el-form-item
          label="谷歌验证码"
          prop="googleCode"
          :rules="[
            {
              required: true,
              message: '请输入谷歌验证码',
            },
          ]"
        >
          <el-input v-model.trim="form.googleCode"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="handleCloseGoogle">取消</el-button>
        <el-button type="primary" @click="handleGoogle">确定</el-button>
      </div>
    </el-dialog>
    <!-- <div class="google" v-if="!showList">
      <a @click="showGoogle">点击此处进行谷歌验证，进入页面</a>
    </div> -->
  </div>
</template>

<script>
import "./store";
import UserList from "./components/list";
import { mapState, mapActions, mapMutations } from "vuex";
import { QUERY_TYPE, PAGINATION } from "./constants";
import moment from "moment";
import DonateCoin from "./components/donateCoin";
import cookies from "js-cookie";

export default {
  name: "giftCoin",
  components: {
    UserList,
    DonateCoin,
  },
  data() {
    return {
      value2: "",
      dialogVisible: false,
      userId: "",
      channelId: "",
      channelUserId: "",
      inviteBy: "",
      value1: "",
      // value1: [
      //   moment(new Date().getTime() - 7 * 1000 * 24 * 60 * 60).format(
      //     'YYYY-MM-DD'
      //   ),
      //   new Date().getFullYear() +
      //     '-' +
      //     (new Date().getMonth() + 1) +
      //     '-' +
      //     new Date().getDate(),
      // ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      form: {
        googleCode: "",
      },
    };
  },
  computed: {
    ...mapState("giftCoin", [
      "queryType",
      "pagination",
      "infoTotal",
      "showList",
      "googleVisible",
    ]),
    ...mapState(["userInfo"]),
    isCustom() {
      // let flag = false;
      // this.userInfo.roles
      //   ? (flag = this.userInfo.roles.some(
      //       (item) => item.productId == 5 && item.name === "客服"
      //     ))
      //   : (flag = true);
      // return flag;
      return false;
    },
  },
  methods: {
    ...mapActions("giftCoin", [
      "list",
      "addUser",
      "getTotalInfo",
      "getSendToken",
    ]),
    ...mapMutations("giftCoin", [
      "setQueryType",
      "setGoogleVisible",
      "setShowList",
    ]),
    ...mapActions("userOld", ["checkGoogle"]),

    showGoogle() {
      this.setGoogleVisible(true);
    },
    handleCloseGoogle() {
      this.setGoogleVisible(false);
    },
    handleGoogle() {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.checkGoogle({ googleCode: this.form.googleCode }).then(
            async ({ code, msg }) => {
              if (code > -1) {
                this.handleCloseGoogle();
                this.setShowList(true);
                this.getSendToken().then((res) => {
                  if (res.code == 0) {
                    cookies.set("send-token", res.data);
                    this.list({
                      startTime: this.value1 ? this.value1[0] : "",
                      endTime: this.value1 ? this.value1[1] : "",
                      userId: this.userId,
                      ...PAGINATION,
                    });
                    this.getTotalInfo({
                      startTime: this.value1 ? this.value1[0] : "",
                      endTime: this.value1 ? this.value1[1] : "",
                      userId: this.userId,
                    });
                  }
                });
              } else {
                this.$message.error(msg);
              }
            }
          );
        }
      });
    },
    refreshList(data = {}) {
      this.list({
        startTime: this.value1 ? this.value1[0] : "",
        endTime: this.value1 ? this.value1[1] : "",
        userId: this.userId,
        ...this.pagination,
        ...data,
      });
      this.getTotalInfo({
        startTime: this.value1 ? this.value1[0] : "",
        endTime: this.value1 ? this.value1[1] : "",
        userId: this.userId,
      });
    },

    donateCoin() {},
    searchYesterday() {
      this.value1 = [
        moment(new Date().getTime() - 1 * 1000 * 24 * 60 * 60).format(
          "YYYY-MM-DD"
        ),
        moment(new Date().getTime() - 1 * 1000 * 24 * 60 * 60).format(
          "YYYY-MM-DD"
        ),
      ];
      this.handleSearch();
    },
    searchToday() {
      this.value1 = [
        new Date().getFullYear() +
          "-" +
          (new Date().getMonth() + 1) +
          "-" +
          new Date().getDate(),
        new Date().getFullYear() +
          "-" +
          (new Date().getMonth() + 1) +
          "-" +
          new Date().getDate(),
      ];
      this.handleSearch();
    },
    handleSearch() {
      this.list({
        startTime: this.value1 ? this.value1[0] : "",
        endTime: this.value1 ? this.value1[1] : "",
        userId: this.userId,
        ...PAGINATION,
      });
      this.getTotalInfo({
        startTime: this.value1 ? this.value1[0] : "",
        endTime: this.value1 ? this.value1[1] : "",
        userId: this.userId,
      });
    },
    handleSave() {},
    closeDialog() {
      this.dialogVisible = false;
    },
    onOpen() {},
    onClose() {
      this.$refs["elForm"].resetFields();
      this.dialogVisible = false;
    },
    close() {
      // this.$emit("update:visible", false);
      this.$refs["elForm"].resetFields();
      this.dialogVisible = false;
    },
  },
  created() {
    if (cookies.get("send-token")) {
      this.list({
        userId: this.userId,
        startTime: this.value1 ? this.value1[0] : "",
        endTime: this.value1 ? this.value1[1] : "",
        ...PAGINATION,
      });
      this.getTotalInfo({
        startTime: this.value1 ? this.value1[0] : "",
        endTime: this.value1 ? this.value1[1] : "",
        userId: this.userId,
      });
    }
  },
};
</script>

<style lang="less" src="../../styles/button.less" scoped></style>
<style lang="less" scoped>
.google {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  a {
    color: blue;
    text-decoration: underline;
  }
}
</style>
